export const DEFAULT_COMPUTE_CIRCLE_RADIUS = 10
